/**
 * WorkshopDetailsCard — the Basics + Schedule card. Its Edit button opens one
 * edit mode for both sections, and Save commits them as a single change.
 */
import type { WorkshopDetail } from '../../../../api/workshops';

import { BasicsSection } from './BasicsSection';
import { ScheduleSection } from './ScheduleSection';
import type { WorkshopEditForm } from './useWorkshopEditForm';
import { WorkshopEditActions } from './WorkshopEditActions';

interface Props {
  workshop: WorkshopDetail;
  form: WorkshopEditForm;
  editable: boolean;
}

export function WorkshopDetailsCard({ workshop, form, editable }: Props) {
  return (
    <section className="nb-card" style={{ display: 'flex', flexDirection: 'column', gap: 22 }}>
      {editable && (
        <div style={{ display: 'flex', justifyContent: 'flex-end', gap: 8, marginBottom: -10 }}>
          <WorkshopEditActions
            editing={form.editing}
            saving={form.saving}
            onEdit={form.startEditing}
            onCancel={form.cancel}
            onSave={() => void form.submit()}
          />
        </div>
      )}
      <BasicsSection
        workshop={workshop}
        editing={form.editing}
        draft={form.draft}
        errors={form.errors}
        setField={form.setField}
      />
      <ScheduleSection
        workshop={workshop}
        editing={form.editing}
        draft={form.draft}
        errors={form.errors}
        setField={form.setField}
      />
    </section>
  );
}
